import { Flex } from '@chakra-ui/react'
import { ReactQueryDevtools } from 'react-query/devtools'
import Header from 'src/components/Header/Header'

export default function MainLayout({ children }) {
  return (
    <>
      <Header />
      <Flex
        as="main"
        direction="column"
        align="center"
        maxW={{ xl: '1200px' }}
        m="0 auto"
        paddingBottom="50px"
        px="10px"
      >
        {children}
      </Flex>
      <ReactQueryDevtools />
    </>
  )
}
